import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice";
import { termSlice } from "./features/term/termSlice";
import { levelBadgeSlice } from "./features/common/levelBadgeSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    term: termSlice.reducer,
    level: levelBadgeSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
